import { useFormContext } from 'react-hook-form';
import { useFlowsDispatch } from '../../../common/src/utils/globalVariables';
import {
  checkQuestionnaire,
  updateAnswers,
} from '../store/redux/slices/flowsSlice';
import { FlowsQuestionAnswer } from '../types/FlowsTypes';
import { useFlowsProgression } from './useFlowsProgression';

interface UseFlowsAnswer {
  fillAnswers: (arg0: FlowsQuestionAnswer[]) => void;
}

const useFlowsAnswer = (): UseFlowsAnswer => {
  const flowsDispatch = useFlowsDispatch();
  const { setValue } = useFormContext();
  const { saveFields } = useFlowsProgression();

  const fillAnswers = (answersParam: FlowsQuestionAnswer[]) => {
    let answers;

    if (!Array.isArray(answersParam)) answers = [answersParam];
    else answers = answersParam;

    flowsDispatch(updateAnswers(answers));
    // Do some extra checks after a question has been answered (like conditions)
    flowsDispatch(checkQuestionnaire());

    answers.forEach(({ id, answer }) => setValue(id, answer));

    saveFields(answers);
  };

  return { fillAnswers };
};

export default useFlowsAnswer;
